'use strict';
module.exports = require('./RadioButton.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/radiobutton/index.js
// module id = 27
// module chunks = 1